const rootActionPath = 'core/PublicBonusTracker';

export const PUBLIC_BONUS_TRACKER_VIEW = `${rootActionPath}/VIEW`;
